export class JwtAuthConstants {
  static readonly TOKEN_EXPIRED = 'TOKEN_EXPIRED';
  static readonly TOKEN_INVALID = 'TOKEN_INVALID';
  static readonly REFRESH_TOKEN_EXPIRED = 'REFRESH_TOKEN_EXPIRED';
}